import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  validationBlock: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: colors.red[600],
    backgroundColor: colors.red[100],
    padding: '1rem',
    borderRadius: '1rem',
    textAlign: 'left',
    maxWidth: '60rem',
    margin: '4rem auto',
    boxSizing: 'border-box',
  },
  validations: {
    marginTop: '1rem',
    marginBottom: 0,
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    paddingLeft: '3rem',
    textAlign: 'left',
    color: colors.neutral[900],
  },
  validationBlockTitle: {
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    color: colors.red[600],
    textAlign: 'center',
    paddingBottom: '1rem',
    borderBottom: `0.1rem solid ${colors.red[300]}`,
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
